export const API_KEY = "AIzaSyCPc9LwXBR1pzTqA1kSK6BGLpTby8vDzCU";

export const DOUBLE_OPT_IN_METHOD = { EMAIL: 'email', PHONE: 'phone' };

export const DOUBLE_OPT_IN_MANDATORY_LIST = ["DE"];

export const LOCAL_NAME_LIST = ["zh", "zh_hk", "kr", "jp" ]; // Per riportare su Kanji Katakana togliere il giapponese

export const KANJI_KATAKANA_LIST = ["jp"];

export const PAGE_STATUS_CONFIRMATION = {
    PENDING: 'pending',
    SUCCESS: 'success',
    ERROR: 'error'
};

export const PAGE_STATUS_LANDING = {
    PENDING: 'pending',
    VALID_UID: 'valid_uid',
    INVALID_UID: 'invalid_uid',
    COMPLETED: 'completed',
    ALREADY_DOUBLE_OPT_IN: 'already_double_opt_in'
};